import { LegalPage } from "@/components/LegalPage";
import { PRIVACY_SECTIONS } from "@/data/legal";

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      title="Privacy Policy"
      intro="This policy explains what we collect when you register a device and how we handle it."
      sections={PRIVACY_SECTIONS}
    />
  );
}
